module.exports = __webpack_public_path__ + "img/go-back-left-arrow.fe319533.svg";